import { useCallback, useContext, useState } from 'react';
import api from 'api';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import { downloadUrlInNewWindow } from 'utils';

const PDF_TYPE = 'application/pdf';

export default function useAgreementExecutionDownload() {
  const { popServerError } = useContext(PopNotificationsContext);

  const [downloadingExecutionId, setDownloadingExecutionId] =
    useState<string>();

  const downloadExecution = useCallback(
    async (executionId: string) => {
      try {
        setDownloadingExecutionId(executionId);

        const {
          data: { url },
        } = await api.agreements.getExecutionDownloadUrl(executionId);

        downloadUrlInNewWindow(url, PDF_TYPE);
      } catch (e) {
        popServerError(e);
      } finally {
        setDownloadingExecutionId(undefined);
      }
    },
    [popServerError],
  );

  return { downloadExecution, downloadingExecutionId };
}
